import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ApiUrlService, View } from '@lib/core';
import { firstValueFrom } from 'rxjs';
import { EnvService } from '@lib/env';

@Component({
    selector: 'insert-api-url',
    templateUrl: './insert-api-url.component.html',
    standalone: false
})
export class InsertApiUrlComponent implements OnInit {
    private readonly apiUrlService = inject(ApiUrlService);
    private readonly router = inject(Router);
    private readonly env = inject(EnvService);


    async ngOnInit(): Promise<void> {
        await firstValueFrom(this.apiUrlService.openApiUrlDialog(this.env.apiUrl ?? ''));
        await this.router.navigate([View.CLIENT, 'login']);
    }
}
